import { DATA } from '../game/data';
import { AIRPLANE_DATA, AIRPLANE_UPGRADES, AirplaneUpgradeType } from '../game/data/airplaneData';
import { AIRPORT_LIST, AIRPORT_UPGRADES, AirportUpgradeType } from '../game/data/airportData';
import { LOUNGE_DATA, LOUNGE_UPGRADES, LoungeUpgradeType } from '../game/data/loungeData';
import { MANAGER_DATA, MANAGER_UPGRADES, ManagerUpgradeType } from '../game/data/managerData';
import { balancePrintTotalBuyPrice } from './totalBuyPrice';
import { printTotalUpgradePrice } from './totalUpgradePrice';

// Assumptions

// average trip length 5 seconds (2..10)

// MANAGER

// LOUNGE

// AIRPORT

// AIRPLANE

export function runBalance() {
  balancePrintTotalBuyPrice();
  //printTotalUpgradePrice();
  // console.log('ADVANCE DATA');
  for (let i = 0; i < 10; i++) {
    console.log(`Level ${i}`, DATA.calculateAdvanceData(i).multiplier, DATA.calculateAdvanceData(i).requiredPassengers);
  }
}
